import { render, staticRenderFns } from "./ChangePwdForm.vue?vue&type=template&id=6e9a32d8"
import script from "./ChangePwdForm.vue?vue&type=script&lang=js"
export * from "./ChangePwdForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports